var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReloadSwitcherIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_134_1405)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.16862 2.48238V1.33577H1.83529V4.66911H5.16862V3.33577H4.22444C5.25579 2.49988 6.56912 1.99984 7.99935 1.99984C11.3131 1.99984 13.9993 4.68613 13.9993 7.99984C13.9993 11.3135 11.3131 13.9998 7.99935 13.9998C4.68564 13.9998 1.99935 11.3135 1.99935 7.99984V7.33317H0.666016V7.99984C0.666016 12.0499 3.94926 15.3332 7.99935 15.3332C12.0494 15.3332 15.3327 12.0499 15.3327 7.99984C15.3327 3.94975 12.0494 0.666504 7.99935 0.666504C6.14886 0.666504 4.45843 1.35233 3.16862 2.48238Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.66602 4.6665V7.7237L10.9422 9.99984L9.99935 10.9426L7.33268 8.27598V4.6665H8.66602Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_134_1405"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReloadSwitcherIcon);
export default __webpack_public_path__ + "static/media/reload-switcher-icon.b7308568cc890f7e30116946158f522a.svg";
export { ForwardRef as ReactComponent };